module.exports = __webpack_public_path__ + "static/media/users (2).095bdb95.svg";